export default __webpack_public_path__ + "15d18640f9617e91244d07bb2e61487d.jpg";